import(/* webpackMode: "eager" */ "/app/client/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/client/node_modules/next/font/google/target.css?{\"path\":\"src/themes/themeOptions.ts\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"display\":\"swap\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/client/src/app/one-trust.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/client/src/app/providers.tsx");
